<template>
  <div class="info-row flex-column align-items-start">
    <div class="info-row__label">
      {{ label }}
    </div>
    <div class="info-row__body d-flex flex-row align-items-center justify-content-between w-100">
      <div class="info-row__content d-flex flex-row align-items-center flex-wrap gap-1">
        <slot />
      </div>
      <div v-if="$slots.action" class="info-row__action d-flex flex-row align-items-center gap-1">
        <slot name="action" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    verticalAlign: {
      type: String,
      default: 'center'
    }
  }
}
</script>

<style scoped>
.info-row {
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid var(--bs-border-color);
  gap: 12px;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row__label {
  width: 90px;
  flex-shrink: 0;
  font-size: 0.8rem;
  color: var(--bs-secondary);
  text-transform: uppercase;
  letter-spacing: 0.025em;
  line-height: 24px;
}

.info-row__content {
  flex: 1;
  min-width: 0;
}

.info-row__action {
  flex: 0 1 auto;
  gap: 4px;
}

@media (max-width: 767.98px) {
  .info-row__body {
    flex-wrap: wrap;
    gap: 8px;
  }

  .info-row__action {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
